/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { Link } from "react-router-dom";

import {
  Advantages,
  Testimonials,
} from 'json/landingPageData';

import Hero from 'parts/Hero';
import StatsGrid from 'parts/StatsGrid';
import Advantage from 'parts/Advantage';
import Testimonial from 'parts/Testimonial';
import CTAFloatCard from 'components/CTAFloatCard';

// SERVICE IMAGES
import managedIT from 'assets/images/Services/services/managed-it-services.jpg';
import Cybersecurity from 'assets/images/Services/services/cybersecurity-services.jpg';
import Disaster from 'assets/images/Services/services/disaster-recovery.jpg';
import Cloud from 'assets/images/Services/services/cloud-solutions.jpg';
import ITConsult from 'assets/images/Services/services/it-consulting.jpg';
import Network from 'assets/images/Services/services/network-security.jpg';
import { Fade } from 'react-awesome-reveal';

import BgImage from '../assets/images/hero/services.png';
import Button from '../elements/Button';

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
          <Hero />

        {/* ══════════════════════════════════════════════════
            🟢 SERVICES SECTION — Premium glassmorphic cards
        ═══════════════════════════════════════════════════ */}
        <section className="py-24 bg-premium-light relative overflow-hidden">
          <div className="container mx-auto px-6 relative z-10">

            <Fade direction="up" triggerOnce>
              <div className="text-center mb-4">
                <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
                  What We Do
                </span>
              </div>
              <h2 className="text-4xl lg:text-5xl text-surface-900 font-extrabold text-center tracking-tight">
                Our IT Services
              </h2>
            </Fade>

            <Fade direction="up" delay={200} triggerOnce>
              <p className="text-center text-surface-300 text-lg max-w-2xl mx-auto mb-16 mt-4">
                Smart, scalable IT solutions built to streamline your workflow, protect your data, and accelerate long-term business growth.
              </p>
            </Fade>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  img: managedIT,
                  title: 'Managed IT Services',
                  desc: 'Reliable, proactive IT support to keep your business running smoothly.',
                  delay: 200,
                },
                {
                  img: Cybersecurity,
                  title: 'Cybersecurity services',
                  desc: 'Protect your business with advanced security solutions.',
                  delay: 300,
                },
                {
                  img: Cloud,
                  title: 'Cloud Solutions',
                  desc: 'Scalable cloud infrastructure tailored to your needs.',
                  delay: 400,
                },
                {
                  img: ITConsult,
                  title: 'IT Consulting',
                  desc: 'Expert guidance to optimize your technology strategy.',
                  delay: 500,
                },
                {
                  img: Disaster,
                  title: 'Disaster Recovery',
                  desc: 'Keep your operations running with robust backup solutions.',
                  delay: 600,
                },
                {
                  img: Network,
                  title: 'Network Security',
                  desc: 'Secure and optimize your network infrastructure.',
                  delay: 700,
                },
              ].map((card) => {
                const slug = card.title
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/gi, '-')
                  .replace(/(^-|-$)+/g, '');

                return (
                  <Fade key={card.title} direction="up" delay={card.delay} triggerOnce>
                    <Link
                      to={`/services/${slug}`}
                      className="glass-card block cursor-pointer flex flex-col min-h-[380px]
                                group focus:outline-none focus:ring-2 focus:ring-brand-green-400 focus:ring-offset-2"
                    >
                      {/* Image */}
                      <div className="w-full h-48 rounded-t-[1.25rem] overflow-hidden relative">
                        <img
                          src={card.img}
                          alt={card.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                      </div>

                      {/* Content */}
                      <div className="p-6 flex-1 flex flex-col">
                        <h3 className="text-lg font-bold text-surface-900 mb-2">
                          {card.title}
                        </h3>

                        <p className="text-surface-300 text-sm flex-1 leading-relaxed">
                          {card.desc}
                        </p>

                        <span className="mt-4 text-brand-green-500 font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                          Learn more
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </span>
                      </div>

                    </Link>
                  </Fade>
                );
              })}
            </div>

            <Fade direction="up" delay={600} triggerOnce>
              <div className="flex justify-center mt-16">
                <a
                  href="/services"
                  className="btn-outline-premium text-base"
                >
                  Explore All Services
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </Fade>

          </div>
        </section>

        {/* Existing content */}
        <Testimonial data={Testimonials} />
        <Advantage data={Advantages} />
        <StatsGrid />

        {/* ═════ DISCUSS HERO ═════ */}
      <Fade direction="up" triggerOnce>
        <section className="relative w-full overflow-hidden">
          {/* TOP CURVED SHAPE */}
          <div className="absolute top-0 w-full overflow-hidden leading-[0] z-10">
            <svg
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
              className="w-full h-[90px] sm:h-[120px]"
            >
              <path
                d="M0,80 C300,0 900,140 1200,40 L1200,0 L0,0 Z"
                fill="#fafbfd"
              />
            </svg>
          </div>

          {/* BACKGROUND */}
          <div className="relative w-full min-h-[520px] sm:min-h-[600px] lg:min-h-[700px] flex items-center">

            <img
              src={BgImage}
              alt="Discuss background"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />

            <div className="absolute inset-0 bg-gradient-to-r from-surface-900/80 via-surface-900/60 to-surface-900/30" />

            {/* CONTENT */}
            <div className="relative z-20 w-full px-5 sm:px-10 lg:px-20">
              <div className="max-w-6xl mx-auto">

                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 mb-8">

                  <h2 className="text-white font-extrabold leading-tight tracking-tight
                    text-3xl sm:text-4xl md:text-5xl lg:text-6xl max-w-3xl"
                  >
                    An IT Partner That Makes Your Life Easier.
                  </h2>

                  <Button
                    href="/contact"
                    type="link"
                    className="btn-premium text-base sm:text-lg px-8 py-4 w-fit"
                  >
                    Contact Us Today!
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Button>
                </div>

                <p className="text-white/80 max-w-3xl text-base sm:text-lg lg:text-xl leading-relaxed">
                  Whether you&apos;re overwhelmed with day-to-day IT tasks or planning a project
                  you&apos;re unsure how to start, we partner with you to deliver IT services
                  that drive real business growth. DNS Computer provides Managed IT Services
                  and Technology Consulting for businesses nationwide.
                </p>

              </div>
            </div>
          </div>
        </section>
      </Fade>

    <CTAFloatCard
      title="Get started today!"
      description="Don't wait to take control of your IT. Schedule your free consultation today, and start building a stronger, more resilient IT foundation for your business."
      buttonText="BOOK A CONSULTATION"
      buttonLink="/book-consultation"
    />
        </>
    );
  }
}
